export const reportTest = (state, rootState) => {
	return state.reportTest;
}

export const quoteList = (state, rootState) => {
	return state.quoteList;
}

export const quotesLoaded = (state, rootState) => {
	return state.quotesLoaded;
}

export const quoteSearchList = (state, rootState) => {
	return state.quoteSearchList;
}

export const quoteSearchListSet = (state, rootState) => {
	return state.quoteSearchListSet;
}

export const specList = (state, rootState) => {
	return state.specList;
}

export const productSalesList = (state, rootState) => {
	return state.productSalesList;
}

export const productSalesProducts = (state, rootState) => {
    return state.productSalesProducts;
}

export const surveyProductCodes = (state, rootState) => {
  return state.surveyProductCodes;
}

export const tenderList = (state, rootState) => {
	return state.tenderList;
}

export const statusList = (state, rootState) => {
	return state.statusList;
}

export const soStatusList = (state, rootState) => {
	return state.soStatusList;
}

export const statusListDropdown = (state, rootState) => {
	var objDropdown = [];
	for( var k in state.statusList  ) {
		var subItem = { text: state.statusList[k].description, obj: state.statusList[k] }
		objDropdown.push(subItem);
	}
	return objDropdown;
}

export const rfcStatusList = (state, rootState) => {
    return state.rfcStatusList;
}

export const objStatusEdit = (state, rootState) => {
	return state.objStatusEdit;
}

export const objRfcStatusEdit = (state, rootState) => {
    return state.objRfcStatusEdit;
}

export const objQuoteSettings = (state, rootState) => {
	return state.objQuoteSettings;
}

export const objUserInfo = (state, rootState) => {
	return state.objUserInfo;
}

export const objQuoteHistory = (state, rootState) => {
	return state.objQuoteHistory;
}

export const objTenderFilters = (state, rootState) => {
	return state.objTenderFilters;
}

export const objSalesFilters = (state, rootState) => {
	return state.objSalesFilters;
}

export const rfcList = (state, rootState) => {
    return state.rfcList;
}

export const rfcStatusses = (state, rootState) => {
    return state.rfcStatusses;
}

export const rfcOriginators = (state, rootState) => {
    return state.rfcOriginators;
}

export const rfcCustomers = (state, rootState) => {
    return state.rfcCustomers;
}

export const rfcHistory = (state, rootState) => {
    return state.rfcHistory;
}

export const rfcSearchList = (state, rootState) => {
    return state.rfcSearchList;
}

export const discountList = (state, rootState) => {
	return state.discountList;
}

export const productSaleRange = (state, rootState) => {
	return state.productSaleRange;
}

export const productSalesSelectProducts = (state, rootState) => {
    return state.productSalesSelectProducts;
}

export const singleQuoteData = (state, rootState) => {
	return state.singleQuoteData;
}

export const discountRequestors = (state, rootState) => {
	return state.discountRequestors;
}

export const discountAuthorisers = (state, rootState) => {
	return state.discountAuthorisers;
}

export const objDiscountReportFilters = (state, rootState) => {
	if( state.objDiscountReportFilters.authorizer != '' ) {
		state.objDiscountReportFilters.authorizer = parseInt( state.objDiscountReportFilters.authorizer );
	}
	if( state.objDiscountReportFilters.requestor != '' ) {
		state.objDiscountReportFilters.requestor = parseInt( state.objDiscountReportFilters.requestor );
	}
	return state.objDiscountReportFilters;
}

export const objRfcFilters = (state, rootState) => {
    state.objRfcFilters
	if( state.objRfcFilters.originator != '' ) {
		state.objRfcFilters.originator = parseInt( state.objRfcFilters.originator );
	}
	if( state.objRfcFilters.customer != '' ) {
		state.objRfcFilters.customer = parseInt( state.objRfcFilters.customer );
	}
	return state.objRfcFilters;
}

export const objProductSalesFilters = (state, rootState) => {
	if( state.objProductSalesFilters.originator != '' ) {
		state.objProductSalesFilters.originator = state.objProductSalesFilters.originator;
	}
	if( state.objProductSalesFilters.customer != '' ) {
		state.objProductSalesFilters.customer = state.objProductSalesFilters.customer;
	}
	if( state.objProductSalesFilters.company != '' ) {
		state.objProductSalesFilters.company = state.objProductSalesFilters.company;
	}
	if( state.objProductSalesFilters.quoteStatus != '' ) {
		state.objProductSalesFilters.quoteStatus = state.objProductSalesFilters.quoteStatus;
	}
	if( state.objProductSalesFilters.quoteTenderStatus != '' ) {
		state.objProductSalesFilters.quoteTenderStatus = state.objProductSalesFilters.quoteTenderStatus;
	}
	if( state.objProductSalesFilters.productTenderStatus != '' ) {
		state.objProductSalesFilters.productTenderStatus = state.objProductSalesFilters.productTenderStatus;
	}
	return state.objProductSalesFilters;
}

export const psStatusses = (state, rootState) => {
	return state.psStatusses
}

export const psTenderStatusses = (state, rootState) => {
	return state.psTenderStatusses
}

export const psProductTenderStatusses = (state, rootState) => {
	return state.psProductTenderStatusses
}

export const psOriginators = (state, rootState) => {
	return state.psOriginators
}

export const psCustomers = (state, rootState) => {
	return state.psCustomers
}

export const productSalesSubList = (state, rootState) => {
	return state.productSalesSubList;
}

export const objQuoteFilters = (state, rootState) => {
	return state.objQuoteFilters;
}

export const objSalesOrderFilters = (state, rootState) => {
	return state.objSalesOrderFilters;
}

export const quoteSettings = (state, rootState) => {
	return state.quoteSettings;
}

export const availableReps = (state, rootState) => {
	return state.availableReps;
}

export const currencyRate = (state, payload) => {
	return state.currencyRate;
}

export const specStatusList = (state, payload) => {
	return state.specStatusList;
}

export const salesOrderList = (state, payload) => {
	return state.salesOrderList;
}

export const salesOrderListFilter = (state, payload) => {
	return state.salesOrderListFilter;
}

export const salesOrderVendors = (state, payload) => {
	return state.salesOrderVendors;
}

export const salesOrderListAll = (state, payload) => {
	return state.salesOrderListAll;
}

export const salesOrderStatusses = (state, payload) => {
	return state.salesOrderStatusses;
}

export const soColumns = (state, payload) => {
	return state.soColumns;
}

export const quoteReportLoaded = (state, payload) => {
	return state.quoteReportLoaded;
}

export const objSoSettings = (state, payload) => {
	return state.objSoSettings;
}

export const soLoaded = (state, payload) => {
	return state.soLoaded;
}

export const stockAvailability = (state, payload) => {
	return state.stockAvailability;
}

export const isLoaded = (state, payload) => {
	return state.isLoaded;
}

export const quoteUsers = (state, payload) => {
  return state.quoteUsers;
}

export const newReportFilters = (state, payload) => {
  // return JSON.parse(localStorage.newReportFilters);
  //return JSON.parse(localStorage.getItem('newReportFilters'));
  return state.newReportFilters;
}

export const dashboardData = (state, payload) => {
  return state.dashboardData;
}

export const filterNeedsReload = (state, payload) => {
  return state.filterNeedsReload;
}

export const totalQuoteRecords = (state, payload) => {
  return state.totalQuoteRecords;
}

export const columnsLoading = (state, payload) => {
  return state.columnsLoading;
}

export const departmentStatusFilter = (state, payload) => {
  return state.departmentStatusFilter;
}

export const excelLoading = (state, payload) => {
  return state.excelLoading;
}

export const manufacturerAudits = (state, payload) => {
  return state.manufacturerAudits;
}

export const surveyFiles = (state, payload) => {
  return state.surveyFiles;
}

export const systemSettings = (state, payload) => {
  return state.systemSettings;
}

export const surveyList = (state, payload) => {
  return state.surveyList;
}

export const surveyListQuotes = (state, payload) => {
  return state.surveyListQuotes;
}

export const quoteLinks = (state, payload) => {
  return state.quoteLinks;
}

export const editLoading = (state, payload) => {
  return state.editLoading;
}

export const soFilters = (state, payload) => {
  return state.soFilters;
}

export const filterNeedsReloadSo = (state, payload) => {
  return state.filterNeedsReloadSo;
}

export const soExcelLoading = (state, payload) => {
  return state.soExcelLoading;
}

export const summaryLoading = (state, payload) => {
  return state.summaryLoading;
}

export const soReps = (state, payload) => {
  return state.soReps;
}

export const statusEdit = (state, payload) => {
  return state.statusEdit;
}

export const getSummaryStatusList = (state, payload) => {
  return state.SummaryStatusList;
}

export const getSummaryRoleList = (state, payload) => {
  return state.SummaryRoleList;
}

export const topTabsCount = (state, payload) => {
  return state.topTabsCount;
}

export const totalPending = (state, payload) => {
  return state.totalPending;
}

export const selectedSearchTab = (state, payload) => {
  return state.Search_Set_Selected_Tab;
}

export const tabWithQuotes = (state, payload) => {
  return state.selectedTabWithQuotes;
}

export const convertLoading = (state, payload) => {
  return state.convertLoading;
}

export const notificationHistoryLoaded = (state, payload) => {
  return state.notificationHistoryLoaded;
}

export const notificationHistory = (state, payload) => {
  return state.notificationHistory;
}

export const getallFilters = (state, payload) => {
  return state.allFilters;
}

export const initialFiltersLoaded = (state, payload) => {
  return state.initialFiltersLoaded;
}

export const summaryFilterLoad = (state, payload) => {
  return state.summaryFilterLoad;
}

export const calculatorFilters = (state, payload) => {
  return state.calculatorFilters;
}

export const spineLoading = (state, payload) => {
  return state.spineLoading;
}

export const storeAudits = (state, payload) => {
  return state.storeAudits;
}

export const vendorListCodes = (state, payload) => {
  return state.vendorListCodes;
}

export const archivedQuotes = (state, payload) => {
  return state.archivedQuotes;
}

export const surveyCalculators = (state, payload) => {
  return state.surveyCalculators;
}

export const surveyListProcess = (state, payload) => {
  return state.surveyListProcess;
}

export const quoteApis = (state, payload) => {
  return state.quoteApis;
}

export const quotesLite = (state, payload) => {
  return state.quotesLite;
}

export const quotesLiteFilters = (state, payload) => {
  return state.quotesLiteFilters;
}

export const quoteSingle = (state, payload) => {
  console.log('Testing');
  return state.quoteSingle;
}

export const filtersLoading = (state, payload) => {
  return state.filtersLoading;
}

export const quoteLiteLoaded = (state, payload) => {
  return state.quoteLiteLoaded;
}

export const quoteLiteContentClick = (state, payload) => {
  return state.quoteLiteContentClick;
}

export const quoteLiteSingle = (state, payload) => {
  return state.quoteLiteSingle;
}

export const quoteLiteContentLoaded = (state, payload) => {
  return state.quoteLiteContentLoaded;
}

export const quoteRepsLite = (state, payload) => {
  return state.quoteRepsLite;
}

export const liteColumns = (state, payload) => {
  return state.liteColumns;
}

export const liteFilterLoaded = (state, payload) => {
  return state.liteFilterLoaded;
}
